var dimensions = [
  {
    id: 3,
    color: ["#af6bb0"],
    title: "Placeholder_1",
    barTitle: "Placeholder_Dimension_1",
    description: `This is a placeholder for employee data to be monitored by managers. Data is obtained via the employee
    Web Application. This data in no way reflects actual values.`,
    data: {
      labels: [
        "Jan 2019",
        "Apr 2019",
        "Jul 2019",
        "Oct 2019",
        "Jan 2020",
        "Apr 2020",
        "Jul 2020",
      ],
      series: [[4, 84, 92, 88, 95, 15, 19]],
      mockData: [{ name: "placeholder", data: [5, 45, 35, 78, 15, 15, 19] }],
      currentAverage: 91,
    },
  },
  {
    id: 4,
    color: ["#47bac1"],
    title: "Placeholder_2",
    barTitle: "Placeholder_Dimension_2",
    description: `This is a placeholder for employee data to be monitored by managers. Data is obtained via the employee
    Web Application. This data in no way reflects actual values.`,
    data: {
      labels: [
        "Jan 2019",
        "Apr 2019",
        "Jul 2019",
        "Oct 2019",
        "Jan 2020",
        "Apr 2020",
        "Jul 2020",
      ],
      series: [[54, 44, 32, 78, 55, 45, 89]],
      mockData: [{ name: "placeholder", data: [5, 45, 35, 34, 34, 34, 19] }],
      currentAverage: 56,
    },
  },
  {
    id: 5,
    color: ["#6b5b95"],
    title: "Placeholder_3",
    barTitle: "Placeholder_Dimension_3",
    description: `This is a placeholder for employee data to be monitored by managers. Data is obtained via the employee
    Web Application. This data in no way reflects actual values.`,
    data: {
      labels: [
        "Jan 2019",
        "Apr 2019",
        "Jul 2019",
        "Oct 2019",
        "Jan 2020",
        "Apr 2020",
        "Jul 2020",
      ],
      series: [[14, 45, 35, 78, 65, 15, 32]],
      mockData: [{ name: "placeholder", data: [5, 4, 3, 7, 1, 1, 19] }],
      currentAverage: 69,
    },
  },
  {
    id: 6,
    color: ["#15a4fa"],
    title: "Placeholder_4",
    barTitle: "Placeholder_Dimension_4",
    description: `This is a placeholder for employee data to be monitored by managers. Data is obtained via the employee
    Web Application. This data in no way reflects actual values.`,
    data: {
      labels: [
        "Jan 2019",
        "Apr 2019",
        "Jul 2019",
        "Oct 2019",
        "Jan 2020",
        "Apr 2020",
        "Jul 2020",
      ],
      series: [[54, 44, 32, 78, 55, 45, 89]],
      mockData: [{ name: "placeholder", data: [52, 34, 39, 18, 15, 1, 91] }],
      currentAverage: 53,
    },
  },
  {
    id: 7,
    color: ["#a2b9bc"],
    title: "Placeholder_5",
    barTitle: "Placeholder_Dimension_5",
    description: `This is a placeholder for employee data to be monitored by managers. Data is obtained via the employee
    Web Application. This data in no way reflects actual values.`,
    data: {
      labels: [
        "Jan 2019",
        "Apr 2019",
        "Jul 2019",
        "Oct 2019",
        "Jan 2020",
        "Apr 2020",
        "Jul 2020",
      ],
      series: [[5, 34, 3, 18, 15, 15, 19]],
      mockData: [{ name: "placeholder", data: [5, 34, 3, 18, 15, 15, 19] }],
      currentAverage: 80,
    },
  },
  /*
  {
    id: 6,
    color: ["#15a4fa"],
    title: "Competency At Work",
    barTitle: "Work Life Balance Over Time",
    description: `This dimension represents your employees' perception of their work-life balance.
      This includes the time they have f better work-life balance which is important for overall wellbeing.`,
    data: {
      labels: [
        "Jan 2019",
        "Apr 2019",
        "Jul 2019",
        "Oct 2019",
        "Jan 2020",
        "Apr 2020",
        "Jul 2020",
      ],
      series: [[54, 44, 32, 78, 55, 45, 89]],
      mockData: [{ name: "placeholder", data: [54, 44, 32, 78, 55, 45, 89] }],
      currentAverage: 0,
    },
  },
  {
    id: 7,
    color: ["#af6bb0"],
    title: "Work Life Balance",
    barTitle: "Work Life Balance Over Time",
    description: `This dimension represents your employees' perception of their work-life balance.
        This includes the time they have f better work-life balance which is important for overall wellbeing.`,
    data: {
      labels: [
        "Jan 2019",
        "Apr 2019",
        "Jul 2019",
        "Oct 2019",
        "Jan 2020",
        "Apr 2020",
        "Jul 2020",
      ],
      series: [[54, 44, 32, 78, 55, 45, 89]],
      mockData: [{ name: "placeholder", data: [54, 44, 32, 78, 55, 45, 89] }],
      currentAverage: 0,
    },
  },
  {
    id: 8,
    color: ["#af6bb0"],
    title: "Workplace Relationships",
    barTitle: "Work Life Balance Over Time",
    description: `This dimension represents your employees' perception of their work-life balance.
        This includes the time they have f better work-life balance which is important for overall wellbeing.`,
    data: {
      labels: [
        "Jan 2019",
        "Apr 2019",
        "Jul 2019",
        "Oct 2019",
        "Jan 2020",
        "Apr 2020",
        "Jul 2020",
      ],
      series: [[54, 44, 32, 78, 55, 45, 89]],
      mockData: [{ name: "placeholder", data: [54, 44, 32, 78, 55, 45, 89] }],
      currentAverage: 0,
    },
  },
  {
    id: 9,
    color: ["#af6bb0"],
    title: "Meaningful Career",
    barTitle: "Work Life Balance Over Time",
    description: `This dimension represents your employees' perception of their work-life balance.
        This includes the time they have f better work-life balance which is important for overall wellbeing.`,
    data: {
      labels: [
        "Jan 2019",
        "Apr 2019",
        "Jul 2019",
        "Oct 2019",
        "Jan 2020",
        "Apr 2020",
        "Jul 2020",
      ],
      series: [[54, 44, 32, 78, 55, 45, 89]],
      mockData: [{ name: "placeholder", data: [54, 44, 32, 78, 55, 45, 89] }],
      currentAverage: 0,
    },
  },
  */
];

export default dimensions;
